import { render, staticRenderFns } from "./HouseGrades.vue?vue&type=template&id=b2ae7f9e&scoped=true&"
import script from "./HouseGrades.vue?vue&type=script&lang=js&"
export * from "./HouseGrades.vue?vue&type=script&lang=js&"
import style0 from "./HouseGrades.vue?vue&type=style&index=0&id=b2ae7f9e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2ae7f9e",
  null
  
)

export default component.exports